import { Metamodel } from '../base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';

import { FormatDatasetV2 } from './dataset.v2';
import { IModel, IAttribute } from '../base/annotation';

@Metamodel.model({
    name: adfModelTypeMap.xml.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.ModelName_XmlDataset),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.ModelName_XmlDataset)
    ]
})
export class XmlDataset extends FormatDatasetV2 {
    public static readonly MODEL: IModel;
    public static readonly ENCODING_NAME: IAttribute;
    public static readonly COMPRESSION_CODEC: IAttribute;
    public static readonly COMPRESSION_LEVEL: IAttribute;
    public static readonly NULL_VALUE: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'ENCODING_NAME',
        display: stringResources.ModelName_Encoding
    })
    public encodingName?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'COMPRESSION_CODEC',
        accepts:['String'],
        display: stringResources.ModelName_CompressionCodec
    })
    public compressionCodec?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'COMPRESSION_LEVEL',
        display: stringResources.ModelName_CompressionLabel
    })
    public compressionLevel?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'NULL_VALUE',
        display: stringResources.NullValueFieldLabel
    })
    public nullValue?: string;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
